const baseUrl = 'https://iot.aquasense.tech/v1'

export default baseUrl
